import React from 'react';
import ServicePageTemplate from './ServicePageTemplate';
import { softwareDevelopmentModasaConfig } from './servicePageConfigs';

const ServiceSoftwareModasa = () => <ServicePageTemplate {...softwareDevelopmentModasaConfig} />;

export default ServiceSoftwareModasa;
